module.exports = __webpack_public_path__ + "img/features01-02_x2.07d4ba2.jpg";